'use client';

import type { Cruz } from '@cruz-com/lookup';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useMount } from 'ahooks';
import { usePathname } from 'next/navigation';
import { createContext, type ReactNode, useContext, useRef, useState } from 'react';
import { useStore } from 'zustand';
import { cruzSocket } from '@/lib';
import { createGlobalStore, type GlobalStore } from './store';
export type GlobalStoreApi = ReturnType<typeof createGlobalStore>;
export const GlobalStoreContext = createContext<GlobalStoreApi | undefined>(undefined);
export const GlobalStoreProvider = ({
  children,
  user
}: {
  children: ReactNode;
  user: Cruz.User | null;
}) => {
  const pathName = usePathname();
  useMount(() => {
    if (!cruzSocket.socket) {
      cruzSocket.init(pathName);
    }
  });
  const [queryClient] = useState(() => new QueryClient());
  const storeRef = useRef<GlobalStoreApi>(null);
  if (!storeRef.current) {
    storeRef.current = createGlobalStore({
      user,
      showSignIn: false,
      lead: {
        type: 0,
        vehicle_id: '',
        vehicle_title: ''
      },
      messageToOwnerType: 0,
      scrollTopOver: false,
      showFeedback: false,
      compareVehicleIds: []
    });
  }
  return <GlobalStoreContext.Provider value={storeRef.current}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </GlobalStoreContext.Provider>;
};
export const useGlobalStore = selector => {
  const globalStoreContext = useContext(GlobalStoreContext);
  if (!globalStoreContext) {
    throw new Error("useGlobalStore must be used within GlobalStoreProvider");
  }
  return useStore(globalStoreContext, selector);
};